import { Grid } from "@mui/material";
import PromoStrip from "./PromoStrip";
import AboutUs from "./AboutUs";
import Banner from "./Banner";
import Services from "./Services";
import Hero from "./Hero";
import ChooseUs from "./ChooseUs";
import Work from "./Work";
import Pricing from "./Pricing";
import FAQ from "./FAQ";
import Footer from "./common/Footer";
import Header from "./common/Header";
import CarModel from "./CarModel";
import PlacesInKarnataka from "./PlacesInKarnataka";
import PlacesInSouth from "./PlacesInSouthIndia";
import FeatureSection from "./FeatureSection";

const HomePage = () => {
  return (
    <Grid>
      <PromoStrip />
      <Header />
      <Banner />
      <ChooseUs />
      <CarModel />
      <Services />
      
      
      <PlacesInKarnataka />
      <PlacesInSouth />
      <Work />
      <AboutUs />
      <FeatureSection/>
      <Hero />
      {/* <Pricing /> */}
      <FAQ />
      
      <Footer />
    </Grid>
  );
};

export default HomePage;
